
import PortWindOutageReport$002Emodule from "../../../src/StenaWeather.WeatherServiceUI.Client/Pages/Portwind/PortWindOutageReport.module.scss";
import { collect as collect_1, sortByDescending, isEmpty, tryHead, exists as exists_1, append as append_1, length, choose, filter, sortBy, initialize, toArray as toArray_1, partition, empty, singleton as singleton_1, ofArray, map } from "../../fable_modules/fable-library-js.5.0.0/List.js";
import { concat, interpolate, printf, toText, join } from "../../fable_modules/fable-library-js.5.0.0/String.js";
import { cn as cn_2 } from "../Dashboard.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { map as map_2, toArray as toArray_2, empty as empty_1, collect, exists, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0/Seq.js";
import { tryFind, ofList } from "../../fable_modules/fable-library-js.5.0.0/Map.js";
import { createObj, int32ToString, compare as compare_1, disposeSafe, getEnumerator, equals, comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { Fragment, useMemo, useContext, createElement } from "react";
import React from "react";
import { HeadingModule_View } from "../../Components/StenaWebUI/Core/Heading.js";
import { Report__get_DelayedTime, IssueKind, StreamModule_label, Issue__get_Duration, Report__get_MaxDelay, Report__get_DelayedPoints, Report__get_LongestGap, Report__get_CurrentGap, Report__get_MissingTime, Report__get_DataCoverage, Report__get_Availability, timeline, analyse, Report__get_Issues, Issue_$reflection, HealthModule_ofReport, Report_$reflection, Health, Health_$reflection, ThresholdsModule_Default } from "../../StenaWeather.Domain/PortWindOutage.js";
import { totalSeconds, fromMinutes, fromHours } from "../../fable_modules/fable-library-js.5.0.0/TimeSpan.js";
import { FSharpRef, toString, Record, Union } from "../../fable_modules/fable-library-js.5.0.0/Types.js";
import { int32_type, option_type, float64_type, class_type, tuple_type, list_type, string_type, record_type, bool_type, union_type } from "../../fable_modules/fable-library-js.5.0.0/Reflection.js";
import { Color, theme } from "../../Theme.js";
import { IconModule_View } from "../../Components/StenaWebUI/Icons/Icon.js";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { DateTimeRange, SensorId_$reflection, SensorId__get_Value, SensorMetaData_$reflection } from "../../StenaWeather.Domain/PortWind.js";
import { defaultArgWith, filter as filter_1, bind, some, value as value_34, toArray, map as map_1, defaultArg } from "../../fable_modules/fable-library-js.5.0.0/Option.js";
import { equals as equals_1, compare, getTicks } from "../../fable_modules/fable-library-js.5.0.0/Date.js";
import { Response_SensorsLastUpdated_$reflection } from "../../StenaWeather.WeatherServiceUI.Shared/PortWind/API.js";
import { ServerError_$reflection } from "../../StenaWeather.WeatherServiceUI.Shared/Errors.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.5.0.0/Result.js";
import { op_Subtraction, minValue, addHours, utcNow } from "../../fable_modules/fable-library-js.5.0.0/DateOffset.js";
import { Cmd_OfAsync_eitherAsResult, onPortWindAPI } from "../../Server.js";
import { singleton as singleton_2 } from "../../fable_modules/fable-library-js.5.0.0/AsyncBuilder.js";
import { Cmd_none, Cmd_ofEffect } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { item } from "../../fable_modules/fable-library-js.5.0.0/Array.js";
import { catchAsync, parallel, ignore, startImmediate } from "../../fable_modules/fable-library-js.5.0.0/Async.js";
import { parse, min } from "../../fable_modules/fable-library-js.5.0.0/Double.js";
import { newGuid } from "../../fable_modules/fable-library-js.5.0.0/Guid.js";
import { formatToMultipleUnits } from "../../TimeSpan.js";
import { PageModule_toUrlSegments } from "../../Router.js";
import { RouterModule_trySeparateLast, RouterModule_encodeQueryString, RouterModule_encodeParts } from "../../lib/Feliz.Router/Router.js";
import { Page, Router_goToUrl } from "../../Router.js";
import { SpaceModule_View } from "../../Components/StenaWebUI/Core/Space.js";
import { TextModule_View } from "../../Components/StenaWebUI/Core/Text.js";
import { TextSize, TextVariant } from "../../Components/StenaWebUI/Core/Text.js";
import { RowModule_View } from "../../Components/StenaWebUI/Core/Row.js";
import { DateTimeOffset_adjustFromContext, DateTimeOffset_dateTimeStr, DateTimeOffset_DateTimeWithTimezone } from "../../Components/TimeZones/Components.js";
import { timeZoneContext } from "../../Components/TimeZones/Context.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { StandardTableModule_view } from "../../Components/StenaWebUI/Grid/StandardTable.js";
import { ViewHelpers_fallbackDataBanner, ViewHelpers_mkRowWith, ViewHelpers_mkRow } from "./PortWindCommon.js";
import { BreadCrumbsModule_View, CrumbModule_View, ReactRouterCrumb_View } from "../../Components/StenaWebUI/Elements/Breadcrumbs.js";
import { PageTitle_title } from "../../SharedView.js";
import { defaultOf as defaultOf_1 } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { compare as compare_2 } from "../../fable_modules/fable-library-js.5.0.0/BigInt.js";
import { UseElmishHelper_programWithCustomErrorHandler, React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.5.0.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";

const cnPage = (() => {
    const styles = PortWindOutageReport$002Emodule;
    const cnFn = (name) => (styles[name]);
    const cnFns = (names) => map((x) => (styles[x]), names);
    return {
        className: cnFn,
        classes: cnFns,
        prop: {
            className: (arg) => ["className", cnFn(arg)],
            classes: (arg_1) => ["className", join(" ", cnFns(arg_1))],
        },
    };
})();

const cnDashboard = cn_2;

function pageContainer(children) {
    return HtmlHelper_createElement("div", ofArray([["className", join(" ", [cnDashboard.className("contentDiv"), cnPage.className("page")])], ["children", children]]));
}

function section(title, children) {
    return HtmlHelper_createElement("div", ofArray([["className", cnDashboard.className("tableWithHeading")], ["children", toList(delay(() => {
        let p_1_1;
        return append(singleton((p_1_1 = ofList(map((value_4) => value_4, ofArray([["variant", "h3"], ["children", singleton_1(title)]])), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }), createElement(HeadingModule_View, {
            p: p_1_1,
        }))), delay(() => children));
    }))]]));
}

const thresholds = ThresholdsModule_Default;

const windowOptions = ofArray([6, 12, 24, 48, 3 * 24, 7 * 24, 14 * 24, 30 * 24]);

const defaultWindowHours = 24;

function windowLabel(hours) {
    if ((hours >= 24) && ((hours % 24) === 0)) {
        const arg = hours / 24;
        return toText(printf("%gd"))(arg);
    }
    else {
        return toText(printf("%gh"))(hours);
    }
}

const avgWindow = fromHours(0);

const concurrency = 16;

/**
 * What the table shows: the health the report decides, plus the one state that is about the
 * report rather than about the sensor.
 */
export class SensorHealth extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Reported", "Pending", "Failed"];
    }
}

export function SensorHealth_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.PortWindOutageReport.SensorHealth", [], SensorHealth, () => [[["Item", Health_$reflection()]], [], []]);
}

export function SensorHealthModule_text(_arg) {
    let matchResult;
    switch (_arg.tag) {
        case 1: {
            matchResult = 4;
            break;
        }
        case 2: {
            matchResult = 5;
            break;
        }
        default:
            switch (_arg.fields[0].tag) {
                case 2: {
                    matchResult = 1;
                    break;
                }
                case 3: {
                    matchResult = 2;
                    break;
                }
                case 4: {
                    matchResult = 3;
                    break;
                }
                case 1: {
                    matchResult = 5;
                    break;
                }
                default:
                    matchResult = 0;
            }
    }
    switch (matchResult) {
        case 0:
            return "OK";
        case 1:
            return "Delayed";
        case 2:
            return "Past outage";
        case 3:
            return "Outage now";
        case 4:
            return "Reading ...";
        default:
            return "No data";
    }
}

export function SensorHealthModule_color(_arg) {
    let matchResult;
    switch (_arg.tag) {
        case 1: {
            matchResult = 4;
            break;
        }
        case 2: {
            matchResult = 5;
            break;
        }
        default:
            switch (_arg.fields[0].tag) {
                case 2: {
                    matchResult = 1;
                    break;
                }
                case 3: {
                    matchResult = 2;
                    break;
                }
                case 4: {
                    matchResult = 3;
                    break;
                }
                case 1: {
                    matchResult = 5;
                    break;
                }
                default:
                    matchResult = 0;
            }
    }
    switch (matchResult) {
        case 0:
            return theme(new Color(21, []));
        case 1:
            return theme(new Color(20, []));
        case 2:
            return "var(--lhds-color-orange-800)";
        case 3:
            return theme(new Color(19, []));
        case 4:
            return theme(new Color(2, []));
        default:
            return "var(--lhds-color-ui-900)";
    }
}

export function SensorHealthModule_icon(health) {
    let t_1;
    return IconModule_View(ofList(map((value) => value, ofArray([["size", 10], (t_1 = faCircle, ["icon", t_1]), ["color", SensorHealthModule_color(health)]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }));
}

/**
 * Only what is wrong right now is painted as an error - a sensor that has recovered is a
 * warning, so that the rows needing attention stand out from the ones merely worth reading.
 */
export function SensorHealthModule_rowBackground(_arg) {
    let matchResult;
    switch (_arg.tag) {
        case 2: {
            matchResult = 0;
            break;
        }
        case 1: {
            matchResult = 2;
            break;
        }
        default:
            switch (_arg.fields[0].tag) {
                case 3:
                case 2: {
                    matchResult = 1;
                    break;
                }
                case 0: {
                    matchResult = 2;
                    break;
                }
                default:
                    matchResult = 0;
            }
    }
    switch (matchResult) {
        case 0:
            return {
                background: theme(new Color(16, [])),
            };
        case 1:
            return {
                background: theme(new Color(17, [])),
            };
        default:
            return {
                background: theme(new Color(1, [])),
            };
    }
}

export function IssueKind_health(_arg) {
    if (_arg.tag === 1) {
        return new SensorHealth(0, [new Health(2, [])]);
    }
    else {
        return new SensorHealth(0, [new Health(4, [])]);
    }
}

export function IssueKind_label(_arg) {
    if (_arg.tag === 1) {
        return "Delayed";
    }
    else {
        return "Gap";
    }
}

/**
 * Where a sensor is up to. Every sensor is listed as soon as the sensor list is in, so the
 * page is a usable list of links while the measurements are still being read.
 */
export class RowState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Pending", "Loaded", "Failed"];
    }
}

export function RowState_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.PortWindOutageReport.RowState", [], RowState, () => [[], [["Item", Report_$reflection()]], []]);
}

/**
 * One row of the sensor table: what the analysis found, plus how the data was obtained.
 */
export class SensorRow extends Record {
    constructor(Sensor, State, IsFallbackData) {
        super();
        this.Sensor = Sensor;
        this.State = State;
        this.IsFallbackData = IsFallbackData;
    }
}

export function SensorRow_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.PortWindOutageReport.SensorRow", [], SensorRow, () => [["Sensor", SensorMetaData_$reflection()], ["State", RowState_$reflection()], ["IsFallbackData", bool_type]]);
}

export function SensorRow__get_Report(this$) {
    const matchValue = this$.State;
    switch (matchValue.tag) {
        case 0:
        case 2:
            return undefined;
        default:
            return matchValue.fields[0];
    }
}

export function SensorRow__get_IsPending(this$) {
    return equals(this$.State, new RowState(0, []));
}

export function SensorRow__get_Health(this$) {
    const matchValue = this$.State;
    switch (matchValue.tag) {
        case 1:
            return new SensorHealth(0, [HealthModule_ofReport(matchValue.fields[0])]);
        case 2:
            return new SensorHealth(2, []);
        default:
            return new SensorHealth(1, []);
    }
}

/**
 * One row of the issue table, with the sensor name the issue itself does not carry.
 */
export class IssueRow extends Record {
    constructor(SensorName, Issue) {
        super();
        this.SensorName = SensorName;
        this.Issue = Issue;
    }
}

export function IssueRow_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.PortWindOutageReport.IssueRow", [], IssueRow, () => [["SensorName", string_type], ["Issue", Issue_$reflection()]]);
}

export function IssueRow_OfSensor(name, report) {
    return map((i) => (new IssueRow(name, i)), defaultArg(map_1(Report__get_Issues, report), empty()));
}

export function IssueRow__get_Key(this$) {
    return `${SensorId__get_Value(this$.Issue.SensorId)}-${toString(this$.Issue.Kind)}-${getTicks(this$.Issue.From)}`;
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Load", "OnSensorsLoaded", "OnSensorRow", "SetWindowHours"];
    }
}

export function Msg_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.PortWindOutageReport.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(list_type(SensorMetaData_$reflection()), Response_SensorsLastUpdated_$reflection()), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", tuple_type(list_type(SensorMetaData_$reflection()), Response_SensorsLastUpdated_$reflection())]], [["ErrorValue", ServerError_$reflection()]]])]], [["generation", class_type("System.Guid")], ["Item2", SensorRow_$reflection()]], [["Item", float64_type]]]);
}

export class State extends Record {
    constructor(Sensor, WindowHours, RangeStart, RangeEnd, Total, Rows, Generation, Error$) {
        super();
        this.Sensor = Sensor;
        this.WindowHours = WindowHours;
        this.RangeStart = RangeStart;
        this.RangeEnd = RangeEnd;
        this.Total = Total;
        this.Rows = Rows;
        this.Generation = Generation;
        this.Error = Error$;
    }
}

export function State_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.PortWindOutageReport.State", [], State, () => [["Sensor", option_type(SensorId_$reflection())], ["WindowHours", float64_type], ["RangeStart", class_type("System.DateTimeOffset")], ["RangeEnd", class_type("System.DateTimeOffset")], ["Total", option_type(int32_type)], ["Rows", list_type(SensorRow_$reflection())], ["Generation", class_type("System.Guid")], ["Error", bool_type]]);
}

export function init(sensor) {
    const now = utcNow();
    return [new State(sensor, defaultWindowHours, addHours(now, -defaultWindowHours), now, undefined, empty(), "00000000-0000-0000-0000-000000000000", false), singleton_1((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

function loadSensors(clientSessionId) {
    return onPortWindAPI(clientSessionId, (api) => singleton_2.Delay(() => singleton_2.Bind(api.GetSensors(), (_arg) => singleton_2.Bind(api.GetSensorsLastUpdated(), (_arg_1) => singleton_2.Return([_arg, _arg_1])))));
}

function fetchRows(clientSessionId, generation, rangeStart, rangeEnd, sensors) {
    return Cmd_ofEffect((dispatch) => {
        const loaded = (sensor, lastUpdated, isFallbackData, weather) => (new SensorRow(sensor, new RowState(1, [analyse(thresholds, rangeStart, rangeEnd, sensor.SensorId, lastUpdated, weather)]), isFallbackData));
        const patternInput = partition((tupledArg) => exists((t) => (compare(t, rangeStart) >= 0), toArray(tupledArg[1])), sensors);
        const toQuery_1 = toArray_1(patternInput[0]);
        const enumerator = getEnumerator(patternInput[1]);
        try {
            while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
                const forLoopVar = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
                dispatch(new Msg(2, [generation, loaded(forLoopVar[0], forLoopVar[1], false, empty())]));
            }
        }
        finally {
            disposeSafe(enumerator);
        }
        const next = new FSharpRef(0);
        const takeNext = () => {
            const i = next.contents | 0;
            next.contents = ((i + 1) | 0);
            if (i < toQuery_1.length) {
                return item(i, toQuery_1);
            }
            else {
                return undefined;
            }
        };
        startImmediate(ignore(parallel(initialize(min(concurrency, toQuery_1.length), (_arg_2) => singleton_2.Delay(() => {
            let next$0027 = takeNext();
            return singleton_2.While(() => (next$0027 != null), singleton_2.Delay(() => {
                const patternInput_1 = value_34(next$0027);
                const sensor$0027 = patternInput_1[0];
                return singleton_2.Bind(catchAsync(onPortWindAPI(clientSessionId, (api) => api.GetWeather(sensor$0027.SensorId, [rangeStart, rangeEnd], avgWindow))), (_arg_1) => {
                    let weather_1;
                    const result = _arg_1;
                    dispatch(new Msg(2, [generation, (result.tag === 1) ? ((console.error(some(`PortWind outage report: ${SensorId__get_Value(sensor$0027.SensorId)} failed: ${result.fields[0]}`)), new SensorRow(sensor$0027, new RowState(2, []), false))) : ((weather_1 = result.fields[0], loaded(sensor$0027, patternInput_1[1], weather_1.IsFallbackData, weather_1.Weather)))]));
                    next$0027 = takeNext();
                    return singleton_2.Zero();
                });
            }));
        })))));
    });
}

export function update(clientSessionId, msg, state) {
    switch (msg.tag) {
        case 0: {
            const now = utcNow();
            return [new State(state.Sensor, state.WindowHours, addHours(now, -state.WindowHours), now, undefined, empty(), newGuid(), false), Cmd_OfAsync_eitherAsResult(() => loadSensors(clientSessionId), (Item) => (new Msg(1, [Item])))];
        }
        case 1:
            if (msg.fields[0].tag === 0) {
                let sensors_1;
                const matchValue = state.Sensor;
                if (matchValue == null) {
                    sensors_1 = sortBy((_arg_1) => _arg_1.Name, filter((s_1) => {
                        if (s_1.Enabled && s_1.Visible) {
                            return equals(s_1.GroupChildrens, empty());
                        }
                        else {
                            return false;
                        }
                    }, msg.fields[0].fields[0][0]), {
                        Compare: (x, y) => (comparePrimitives(x, y) | 0),
                    });
                }
                else {
                    const sensorId = matchValue;
                    sensors_1 = filter((s) => equals(s.SensorId, sensorId), msg.fields[0].fields[0][0]);
                }
                const lastUpdatedBySensor = ofList(choose((x_1) => {
                    if (equals_1(x_1.LastUpdated, minValue())) {
                        return undefined;
                    }
                    else {
                        return [x_1.SensorId, x_1.LastUpdated];
                    }
                }, msg.fields[0].fields[0][1].Sensors), {
                    Compare: (x_2, y_1) => (compare_1(x_2, y_1) | 0),
                });
                const withLastUpdated = map((s_2) => [s_2, tryFind(s_2.SensorId, lastUpdatedBySensor)], sensors_1);
                return [new State(state.Sensor, state.WindowHours, state.RangeStart, state.RangeEnd, length(sensors_1), map((s_3) => (new SensorRow(s_3, new RowState(0, []), false)), sensors_1), state.Generation, state.Error), fetchRows(clientSessionId, state.Generation, state.RangeStart, state.RangeEnd, withLastUpdated)];
            }
            else {
                return [new State(state.Sensor, state.WindowHours, state.RangeStart, state.RangeEnd, state.Total, state.Rows, state.Generation, true), Cmd_none()];
            }
        case 2:
            if (msg.fields[0] !== state.Generation) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.Sensor, state.WindowHours, state.RangeStart, state.RangeEnd, state.Total, map((r) => {
                    if (equals(r.Sensor.SensorId, msg.fields[1].Sensor.SensorId)) {
                        return msg.fields[1];
                    }
                    else {
                        return r;
                    }
                }, state.Rows), state.Generation, state.Error), Cmd_none()];
            }
        default:
            return [new State(state.Sensor, msg.fields[0], state.RangeStart, state.RangeEnd, state.Total, state.Rows, state.Generation, state.Error), singleton_1((dispatch) => {
                dispatch(new Msg(0, []));
            })];
    }
}

function Format_duration(t) {
    if (t < fromMinutes(1)) {
        return `${~~totalSeconds(t)}s`;
    }
    else {
        return formatToMultipleUnits(t);
    }
}

const Format_durationOpt = (arg) => defaultArg(map_1(Format_duration, arg), "-");

const Format_percentOpt = (arg) => defaultArg(map_1((x) => (`${interpolate("%.1f%P()", [100 * x])} %`), arg), "-");

const Format_countOpt = (arg) => defaultArg(map_1(int32ToString, arg), "-");

const Format_problemCountOpt = (arg) => defaultArg(map_1((n) => {
    if (n === 0) {
        return "-";
    }
    else {
        return int32ToString(n);
    }
}, arg), "-");

function Format_ofReport(f, row) {
    return map_1(f, SensorRow__get_Report(row));
}

function Format_ofReportOpt(f, row) {
    return bind(f, SensorRow__get_Report(row));
}

function Format_ifReported(row) {
    return filter_1((_arg) => (_arg.LastMeasurement != null), SensorRow__get_Report(row));
}

function Format_ofReported(f, row) {
    return map_1(f, Format_ifReported(row));
}

function Format_ofReportedOpt(f, row) {
    return bind(f, Format_ifReported(row));
}

function linkTo(className, page, label) {
    let tupledArg, queryString;
    return HtmlHelper_createElement("a", ofArray([cnPage.prop.className(className), ["href", (tupledArg = PageModule_toUrlSegments(page), (queryString = tupledArg[1], defaultArgWith(map_1((tupledArg_1) => RouterModule_encodeParts(append_1(tupledArg_1[0], singleton_1(tupledArg_1[1] + RouterModule_encodeQueryString(queryString))), 2), RouterModule_trySeparateLast(tupledArg[0])), () => RouterModule_encodeParts(singleton_1(RouterModule_encodeQueryString(queryString)), 2))))], ["onClick", (e) => {
        Router_goToUrl(e);
    }], ["title", label], ["children", singleton_1(label)]]));
}

function pageLink(page, label) {
    return linkTo("link", page, label);
}

function sensorLink(sensorId, name) {
    return linkTo("cellLink", new Page(9, [sensorId]), name);
}

function HealthCell($props) {
    let p_1_1;
    const p = $props.p;
    const p_1_3 = ofList(map((value_3) => value_3, singleton_1(["children", ofArray([SensorHealthModule_icon(p.value), (p_1_1 = ofList(map((value) => value, empty()), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), createElement(SpaceModule_View, {
        p: p_1_1,
    })), TextModule_View(ofList(map((value_2) => value_2, ofArray([["variant", new TextVariant(0, [])], ["size", new TextSize(0, [])], ["color", theme(new Color(3, []))], ["children", SensorHealthModule_text(p.value)]])), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }))])])), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    });
    return createElement(RowModule_View, {
        p: p_1_3,
    });
}

function KindCell($props) {
    let p_1_1;
    const p = $props.p;
    const p_1_3 = ofList(map((value_3) => value_3, singleton_1(["children", ofArray([SensorHealthModule_icon(IssueKind_health(p.value)), (p_1_1 = ofList(map((value) => value, empty()), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), createElement(SpaceModule_View, {
        p: p_1_1,
    })), TextModule_View(ofList(map((value_2) => value_2, ofArray([["size", new TextSize(0, [])], ["children", IssueKind_label(p.value)]])), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }))])])), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    });
    return createElement(RowModule_View, {
        p: p_1_3,
    });
}

function DateTimeCell($props) {
    const p = $props.p;
    return TextModule_View(ofList(map((value) => value, ofArray([["size", new TextSize(0, [])], ["children", singleton_1(createElement(DateTimeOffset_DateTimeWithTimezone, {
        dateTime: p.value,
    }))]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }));
}

function cellText(value) {
    return HtmlHelper_createElement("div", ofArray([cnPage.prop.className("cellText"), ["title", value], ["children", [TextModule_View(ofList(map((value_4) => value_4, ofArray([["size", new TextSize(0, [])], ["children", value]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }))]]]));
}

function Timeline_color(_arg) {
    if (_arg != null) {
        return SensorHealthModule_color(IssueKind_health(_arg));
    }
    else {
        return theme(new Color(21, []));
    }
}

function Timeline_label(_arg) {
    if (_arg != null) {
        return IssueKind_label(_arg);
    }
    else {
        return "Reporting";
    }
}

function useFormatTime() {
    const ctx = useContext(timeZoneContext);
    return (d) => DateTimeOffset_dateTimeStr(DateTimeOffset_adjustFromContext(ctx, d));
}

function TimelineStrip($props) {
    const report = $props.report;
    const heightPx = $props.heightPx;
    const formatTime = useFormatTime();
    const segments = useMemo(() => timeline(report), [report]);
    const total = totalSeconds(op_Subtraction(report.To, report.From));
    return HtmlHelper_createElement("div", ofArray([["style", {
        display: "flex",
        width: 100 + "%",
        height: heightPx + "px",
        borderRadius: 3 + "px",
        overflow: "hidden",
    }], ["children", toList(delay(() => collect((matchValue) => {
        const to_ = matchValue[2];
        const kind = matchValue[0];
        const from = matchValue[1];
        const duration = op_Subtraction(to_, from);
        return singleton(HtmlHelper_createElement("div", ofArray([["title", `${Timeline_label(kind)}: ${formatTime(from)} - ${formatTime(to_)} (${Format_duration(duration)})`], ["style", {
            width: ((total > 0) ? ((100 * totalSeconds(duration)) / total) : 100) + "%",
            backgroundColor: Timeline_color(kind),
        }]])));
    }, segments)))]]));
}

const sensorColumns = ofArray([["health", (() => {
    const columnProps = createObj(toList(toList(delay(() => append(singleton(["name", "health"]), delay(() => append(singleton(["columnLabel", "Status"]), delay(() => append(empty_1(), delay(() => append(singleton(["width", toText(`${140}px`)]), delay(() => append(singleton(["itemValueResolver", SensorRow__get_Health]), delay(() => singleton(["renderCell", (p) => createElement(HealthCell, {
        p: p,
    })])))))))))))))));
    return [columnProps.name, columnProps];
})()], ["sensor", (() => {
    const columnProps_1 = createObj(toList(toList(delay(() => append(singleton(["name", "sensor"]), delay(() => append(singleton(["columnLabel", "Sensor"]), delay(() => append(empty_1(), delay(() => append(singleton(["width", toText(`${240}px`)]), delay(() => append(singleton(["itemValueResolver", (x) => x]), delay(() => singleton(["renderCell", (p_1) => sensorLink(p_1.item.Sensor.SensorId, p_1.item.Sensor.Name)])))))))))))))));
    return [columnProps_1.name, columnProps_1];
})()], ["timeline", (() => {
    const columnProps_2 = createObj(toList(toList(delay(() => append(singleton(["name", "timeline"]), delay(() => append(singleton(["columnLabel", "Window"]), delay(() => append(singleton(["infoIconTooltipText", "Green = the sensor was reporting, orange = measurements arrived late, red = nothing arrived."]), delay(() => append(singleton(["width", toText(`${260}px`)]), delay(() => append(singleton(["itemValueResolver", SensorRow__get_Report]), delay(() => singleton(["renderCell", (p_2) => {
        const matchValue = p_2.value;
        if (matchValue == null) {
            return defaultOf();
        }
        else {
            const report = matchValue;
            return createElement(TimelineStrip, {
                heightPx: 14,
                report: report,
            });
        }
    }])))))))))))))));
    return [columnProps_2.name, columnProps_2];
})()], ["availability", (() => {
    const columnProps_3 = createObj(toList(toList(delay(() => append(singleton(["name", "availability"]), delay(() => append(singleton(["columnLabel", "Availability"]), delay(() => append(singleton(["infoIconTooltipText", "Share of the window the sensor delivered data without delay."]), delay(() => append(singleton(["width", toText(`${110}px`)]), delay(() => append(singleton(["itemValueResolver", (row) => Format_ofReportOpt(Report__get_Availability, row)]), delay(() => singleton(["renderCell", (p_3) => cellText(Format_percentOpt(p_3.value))])))))))))))))));
    return [columnProps_3.name, columnProps_3];
})()], ["dataCoverage", (() => {
    const columnProps_4 = createObj(toList(toList(delay(() => append(singleton(["name", "dataCoverage"]), delay(() => append(singleton(["columnLabel", "Data coverage"]), delay(() => append(singleton(["infoIconTooltipText", "Share of the window the sensor\'s measurements covers, disregarding delays."]), delay(() => append(singleton(["width", toText(`${140}px`)]), delay(() => append(singleton(["itemValueResolver", (row_1) => Format_ofReportOpt(Report__get_DataCoverage, row_1)]), delay(() => singleton(["renderCell", (p_5) => cellText(Format_percentOpt(p_5.value))])))))))))))))));
    return [columnProps_4.name, columnProps_4];
})()], ["points", (() => {
    const columnProps_5 = createObj(toList(toList(delay(() => append(singleton(["name", "points"]), delay(() => append(singleton(["columnLabel", "Points"]), delay(() => append(empty_1(), delay(() => append(singleton(["width", toText(`${90}px`)]), delay(() => append(singleton(["itemValueResolver", (row_2) => Format_ofReport((_arg_2) => (_arg_2.Points | 0), row_2)]), delay(() => singleton(["renderCell", (p_7) => cellText(Format_countOpt(p_7.value))])))))))))))))));
    return [columnProps_5.name, columnProps_5];
})()], ["interval", (() => {
    const columnProps_6 = createObj(toList(toList(delay(() => append(singleton(["name", "interval"]), delay(() => append(singleton(["columnLabel", "Interval"]), delay(() => append(empty_1(), delay(() => append(singleton(["width", toText(`${110}px`)]), delay(() => append(singleton(["itemValueResolver", (row_3) => Format_ofReportOpt((_arg_3) => _arg_3.TypicalInterval, row_3)]), delay(() => singleton(["renderCell", (p_9) => cellText(Format_durationOpt(p_9.value))])))))))))))))));
    return [columnProps_6.name, columnProps_6];
})()], ["gaps", (() => {
    const columnProps_7 = createObj(toList(toList(delay(() => append(singleton(["name", "gaps"]), delay(() => append(singleton(["columnLabel", "Gaps"]), delay(() => append(empty_1(), delay(() => append(singleton(["width", toText(`${80}px`)]), delay(() => append(singleton(["itemValueResolver", (row_4) => Format_ofReported((_arg_4) => (length(_arg_4.Gaps) | 0), row_4)]), delay(() => singleton(["renderCell", (p_11) => cellText(Format_problemCountOpt(p_11.value))])))))))))))))));
    return [columnProps_7.name, columnProps_7];
})()], ["missing", (() => {
    const columnProps_8 = createObj(toList(toList(delay(() => append(singleton(["name", "missing"]), delay(() => append(singleton(["columnLabel", "Missing"]), delay(() => append(empty_1(), delay(() => append(singleton(["width", toText(`${120}px`)]), delay(() => append(singleton(["itemValueResolver", (row_5) => Format_ofReported(Report__get_MissingTime, row_5)]), delay(() => singleton(["renderCell", (p_13) => cellText(Format_durationOpt(p_13.value))])))))))))))))));
    return [columnProps_8.name, columnProps_8];
})()], ["currentGap", (() => {
    const columnProps_9 = createObj(toList(toList(delay(() => append(singleton(["name", "currentGap"]), delay(() => append(singleton(["columnLabel", "Current gap"]), delay(() => append(singleton(["infoIconTooltipText", "How long the sensor has been currently silent."]), delay(() => append(singleton(["width", toText(`${130}px`)]), delay(() => append(singleton(["itemValueResolver", (row_6) => Format_ofReportedOpt(Report__get_CurrentGap, row_6)]), delay(() => singleton(["renderCell", (p_15) => cellText(Format_durationOpt(p_15.value))])))))))))))))));
    return [columnProps_9.name, columnProps_9];
})()], ["longestGap", (() => {
    const columnProps_10 = createObj(toList(toList(delay(() => append(singleton(["name", "longestGap"]), delay(() => append(singleton(["columnLabel", "Longest gap"]), delay(() => append(empty_1(), delay(() => append(singleton(["width", toText(`${130}px`)]), delay(() => append(singleton(["itemValueResolver", (row_7) => Format_ofReportedOpt(Report__get_LongestGap, row_7)]), delay(() => singleton(["renderCell", (p_17) => cellText(Format_durationOpt(p_17.value))])))))))))))))));
    return [columnProps_10.name, columnProps_10];
})()], ["delayedPoints", (() => {
    const columnProps_11 = createObj(toList(toList(delay(() => append(singleton(["name", "delayedPoints"]), delay(() => append(singleton(["columnLabel", "Delayed points"]), delay(() => append(empty_1(), delay(() => append(singleton(["width", toText(`${140}px`)]), delay(() => append(singleton(["itemValueResolver", (row_8) => Format_ofReport((_arg_8) => (Report__get_DelayedPoints(_arg_8) | 0), row_8)]), delay(() => singleton(["renderCell", (p_19) => cellText(Format_problemCountOpt(p_19.value))])))))))))))))));
    return [columnProps_11.name, columnProps_11];
})()], ["maxDelay", (() => {
    const columnProps_12 = createObj(toList(toList(delay(() => append(singleton(["name", "maxDelay"]), delay(() => append(singleton(["columnLabel", "Max delay"]), delay(() => append(empty_1(), delay(() => append(singleton(["width", toText(`${120}px`)]), delay(() => append(singleton(["itemValueResolver", (row_9) => Format_ofReportOpt(Report__get_MaxDelay, row_9)]), delay(() => singleton(["renderCell", (p_21) => cellText(Format_durationOpt(p_21.value))])))))))))))))));
    return [columnProps_12.name, columnProps_12];
})()]]);

const sensorTableConfig = (() => {
    const columns = sensorColumns;
    return ofArray([["keyResolver", (r) => SensorId__get_Value(r.Sensor.SensorId)], ["disableSorting", true], ["stickyHeader", true], ["rowBackgroundResolver", (r_1) => SensorHealthModule_rowBackground(SensorRow__get_Health(r_1))], ["columns", createObj(map((tuple) => tuple[1], columns))], ["columnOrder", toArray_1(map((tuple_1) => tuple_1[0], columns))]]);
})();

function sensorTable(rows, loading) {
    return HtmlHelper_createElement("div", ofArray([cnPage.prop.className("sensorTableScroll"), ["children", [StandardTableModule_view(createObj(toList([["variant", "compact"], ["items", toArray_2(rows)], ["loading", loading], ["noItemsLabel", "No sensors"], ["config", createObj(toList(sensorTableConfig))]])))]]]));
}

function issueColumns(showSensor) {
    return toList(delay(() => {
        let columnProps;
        return append(showSensor ? singleton(["sensor", (columnProps = createObj(toList(toList(delay(() => append(singleton(["name", "sensor"]), delay(() => append(singleton(["columnLabel", "Sensor"]), delay(() => append(empty_1(), delay(() => append(singleton(["width", toText(`${240}px`)]), delay(() => append(singleton(["itemValueResolver", (x) => x]), delay(() => singleton(["renderCell", (p) => sensorLink(p.item.Issue.SensorId, p.item.SensorName)]))))))))))))))), [columnProps.name, columnProps])]) : empty_1(), delay(() => {
            let columnProps_1;
            return append(singleton(["kind", (columnProps_1 = createObj(toList(toList(delay(() => append(singleton(["name", "kind"]), delay(() => append(singleton(["columnLabel", "Type"]), delay(() => append(empty_1(), delay(() => append(singleton(["width", toText(`${140}px`)]), delay(() => append(singleton(["itemValueResolver", (r) => r.Issue.Kind]), delay(() => singleton(["renderCell", (p_1) => createElement(KindCell, {
                p: p_1,
            })]))))))))))))))), [columnProps_1.name, columnProps_1])]), delay(() => {
                let columnProps_2;
                return append(singleton(["from", (columnProps_2 = createObj(toList(toList(delay(() => append(singleton(["name", "from"]), delay(() => append(singleton(["columnLabel", "From"]), delay(() => append(empty_1(), delay(() => append(singleton(["width", toText(`${180}px`)]), delay(() => append(singleton(["itemValueResolver", (r_1) => r_1.Issue.From]), delay(() => singleton(["renderCell", (p_2) => createElement(DateTimeCell, {
                    p: p_2,
                })]))))))))))))))), [columnProps_2.name, columnProps_2])]), delay(() => {
                    let columnProps_3;
                    return append(singleton(["to", (columnProps_3 = createObj(toList(toList(delay(() => append(singleton(["name", "to"]), delay(() => append(singleton(["columnLabel", "To"]), delay(() => append(empty_1(), delay(() => append(singleton(["width", toText(`${180}px`)]), delay(() => append(singleton(["itemValueResolver", (r_2) => r_2.Issue.To]), delay(() => singleton(["renderCell", (p_3) => createElement(DateTimeCell, {
                        p: p_3,
                    })]))))))))))))))), [columnProps_3.name, columnProps_3])]), delay(() => {
                        let columnProps_4;
                        return append(singleton(["duration", (columnProps_4 = createObj(toList(toList(delay(() => append(singleton(["name", "duration"]), delay(() => append(singleton(["columnLabel", "Duration"]), delay(() => append(empty_1(), delay(() => append(singleton(["width", toText(`${120}px`)]), delay(() => append(singleton(["itemValueResolver", (r_3) => Issue__get_Duration(r_3.Issue)]), delay(() => singleton(["renderCell", (p_4) => cellText(Format_duration(p_4.value))]))))))))))))))), [columnProps_4.name, columnProps_4])]), delay(() => {
                            let tooltip_5, columnProps_5;
                            return append(singleton((tooltip_5 = "Which of the sensor\'s measurement streams this affects, when only some of them are down - a wind outage while the tide keeps reporting. Empty when every stream the sensor sends is down, which is the whole sensor being out.", ["streams", (columnProps_5 = createObj(toList(toList(delay(() => append(singleton(["name", "streams"]), delay(() => append(singleton(["columnLabel", "Parameter stream"]), delay(() => append((tooltip_5 !== "") ? singleton(["infoIconTooltipText", tooltip_5]) : empty_1(), delay(() => append(singleton(["width", toText(`${160}px`)]), delay(() => append(singleton(["itemValueResolver", (r_4) => r_4.Issue.Streams]), delay(() => singleton(["renderCell", (p_6) => cellText(join(", ", map(StreamModule_label, p_6.value)))]))))))))))))))), [columnProps_5.name, columnProps_5])])), delay(() => {
                                let columnProps_6;
                                return singleton(["details", (columnProps_6 = createObj(toList(toList(delay(() => append(singleton(["name", "details"]), delay(() => append(singleton(["columnLabel", "Details"]), delay(() => append(empty_1(), delay(() => append(singleton(["width", toText(`${360}px`)]), delay(() => append(singleton(["itemValueResolver", (x_1) => x_1]), delay(() => singleton(["renderCell", (p_8) => {
                                    const issue = p_8.item.Issue;
                                    const label_11 = (issue.Kind.tag === 1) ? (`${issue.Points} measurement(s), up to ${Format_durationOpt(issue.MaxDelay)} late`) : "No measurement received";
                                    return cellText(issue.IsOngoing ? concat(label_11, ..." - still going on") : label_11);
                                }]))))))))))))))), [columnProps_6.name, columnProps_6])]);
                            }));
                        }));
                    }));
                }));
            }));
        }));
    }));
}

function issuesConfig(showSensor) {
    const columns = issueColumns(showSensor);
    return ofArray([["keyResolver", IssueRow__get_Key], ["disableSorting", true], ["stickyHeader", false], ["rowBackgroundResolver", (r_1) => SensorHealthModule_rowBackground(IssueKind_health(r_1.Issue.Kind))], ["columns", createObj(map((tuple) => tuple[1], columns))], ["columnOrder", toArray_1(map((tuple_1) => tuple_1[0], columns))]]);
}

const issuesConfigWithSensor = issuesConfig(true);

const issuesConfigWithoutSensor = issuesConfig(false);

function issuesTable(showSensor, rows, loading) {
    return StandardTableModule_view(createObj(toList([["variant", "compact"], ["items", toArray_2(rows)], ["loading", loading], ["noItemsLabel", "No gaps or delays found"], ["config", createObj(toList(showSensor ? issuesConfigWithSensor : issuesConfigWithoutSensor))]])));
}

function isLoading(state) {
    if (state.Total == null) {
        return !state.Error;
    }
    else {
        return false;
    }
}

function isReading(state) {
    return exists_1(SensorRow__get_IsPending, state.Rows);
}

function loadedCount(state) {
    return length(filter((r) => !SensorRow__get_IsPending(r), state.Rows)) | 0;
}

function Header($props) {
    const dispatch = $props.dispatch;
    const state = $props.state;
    const minimum = Format_duration(thresholds.Minimum);
    let outageRule;
    const cap = Format_duration(thresholds.GapCap);
    outageRule = (`no measurement for longer than ${interpolate("%g%P()", [thresholds.GapIntervalFactor])}x the sensor's own reporting interval, never less than ${minimum} and always when it is longer than ${cap}.`);
    let delayRule;
    const fallback = Format_duration(thresholds.DelayWithoutInterval);
    delayRule = (`measurements that reached the service with delay more than ${interpolate("%g%P()", [thresholds.DelayIntervalFactor])}x the sensor's own reporting interval, never less than ${minimum} (${fallback} when the interval is not known).`);
    const rule = (health, what, description) => {
        let p_1_1, p_1_3;
        return ViewHelpers_mkRow(ofArray([SensorHealthModule_icon(health), (p_1_1 = ofList(map((value) => value, empty()), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }), createElement(SpaceModule_View, {
            p: p_1_1,
        })), TextModule_View(ofList(map((value_2) => value_2, ofArray([["size", new TextSize(0, [])], ["variant", new TextVariant(3, [])], ["children", what]])), {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        })), (p_1_3 = ofList(map((value_3) => value_3, empty()), {
            Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
        }), createElement(SpaceModule_View, {
            p: p_1_3,
        })), TextModule_View(ofList(map((value_5) => value_5, ofArray([["size", new TextSize(0, [])], ["color", theme(new Color(3, []))], ["children", description]])), {
            Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
        }))]));
    };
    return HtmlHelper_createElement("div", ofArray([["style", {
        marginBottom: 12 + "px",
    }], ["children", [ViewHelpers_mkRow(toList(delay(() => append(singleton(TextModule_View(ofList(map((value_11) => value_11, ofArray([["size", new TextSize(0, [])], ["children", "Time window:"]])), {
        Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
    }))), delay(() => {
        let p_1_6;
        return append(singleton((p_1_6 = ofList(map((value_12) => value_12, empty()), {
            Compare: (x_5, y_5) => (comparePrimitives(x_5, y_5) | 0),
        }), createElement(SpaceModule_View, {
            p: p_1_6,
        }))), delay(() => append(singleton(HtmlHelper_createElement("select", ofArray([cnPage.prop.className("windowSelect"), ["title", "Select time window"], ["onChange", (ev) => {
            dispatch(new Msg(3, [parse(ev.target.value)]));
        }], ["children", toList(delay(() => map_2((hours) => HtmlHelper_createElement("option", toList(delay(() => append(singleton(["children", singleton_1(windowLabel(hours))]), delay(() => append(singleton(["value", hours.toString()]), delay(() => ((hours === state.WindowHours) ? singleton(["selected", true]) : empty_1())))))))), windowOptions)))]]))), delay(() => {
            let p_1_7;
            return append(singleton((p_1_7 = ofList(map((value_25) => value_25, empty()), {
                Compare: (x_6, y_6) => (comparePrimitives(x_6, y_6) | 0),
            }), createElement(SpaceModule_View, {
                p: p_1_7,
            }))), delay(() => append(singleton(TextModule_View(ofList(map((value_27) => value_27, ofArray([["size", new TextSize(0, [])], ["children", ofArray([createElement(DateTimeOffset_DateTimeWithTimezone, {
                dateTime: state.RangeStart,
            }), " - ", createElement(DateTimeOffset_DateTimeWithTimezone, {
                dateTime: state.RangeEnd,
            })])]])), {
                Compare: (x_7, y_7) => (comparePrimitives(x_7, y_7) | 0),
            }))), delay(() => {
                let p_1_9;
                return (state.Sensor == null) ? append(singleton((p_1_9 = ofList(map((value_28) => value_28, empty()), {
                    Compare: (x_8, y_8) => (comparePrimitives(x_8, y_8) | 0),
                }), createElement(SpaceModule_View, {
                    p: p_1_9,
                }))), delay(() => {
                    const total = defaultArg(map_1(int32ToString, state.Total), "?");
                    return singleton(TextModule_View(ofList(map((value_32) => value_32, ofArray([["color", theme(new Color(3, []))], ["children", `${loadedCount(state)} / ${total} sensors`]])), {
                        Compare: (x_9, y_9) => (comparePrimitives(x_9, y_9) | 0),
                    })));
                })) : empty_1();
            }))));
        }))));
    }))))), rule(IssueKind_health(new IssueKind(0, [])), "Outage", outageRule), rule(IssueKind_health(new IssueKind(1, [])), "Delayed", delayRule)]]]));
}

function TimelineBar($props) {
    let p_1_4, p_1_5;
    const report = $props.report;
    const formatTime = useFormatTime();
    const legendEntry = (kind) => ViewHelpers_mkRow(ofArray([HtmlHelper_createElement("div", singleton_1(["style", {
        width: 10 + "px",
        height: 10 + "px",
        borderRadius: 2 + "px",
        backgroundColor: Timeline_color(kind),
        marginRight: 4 + "px",
    }])), TextModule_View(ofList(map((value_14) => value_14, ofArray([["size", new TextSize(0, [])], ["color", theme(new Color(3, []))], ["children", Timeline_label(kind)]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }))]));
    return HtmlHelper_createElement("div", singleton_1(["children", [createElement(TimelineStrip, {
        heightPx: 24,
        report: report,
    }), ViewHelpers_mkRowWith([["justifyContent", "space-between"]], ofArray([TextModule_View(ofList(map((value_16) => value_16, ofArray([["size", new TextSize(0, [])], ["color", theme(new Color(3, []))], ["children", formatTime(report.From)]])), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    })), TextModule_View(ofList(map((value_18) => value_18, ofArray([["size", new TextSize(0, [])], ["color", theme(new Color(3, []))], ["children", formatTime(report.To)]])), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    }))])), ViewHelpers_mkRow(ofArray([legendEntry(undefined), (p_1_4 = ofList(map((value_19) => value_19, empty()), {
        Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
    }), createElement(SpaceModule_View, {
        p: p_1_4,
    })), legendEntry(new IssueKind(1, [])), (p_1_5 = ofList(map((value_20) => value_20, empty()), {
        Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
    }), createElement(SpaceModule_View, {
        p: p_1_5,
    })), legendEntry(new IssueKind(0, []))]))]]));
}

function statTile(label, value) {
    return HtmlHelper_createElement("div", ofArray([["style", {
        minWidth: 130 + "px",
        padding: ((8 + "px") + " ") + (12 + "px"),
        marginRight: 8 + "px",
        marginBottom: 8 + "px",
        backgroundColor: theme(new Color(6, [])),
        borderRadius: 4 + "px",
    }], ["children", [HtmlHelper_createElement("div", ofArray([["style", {
        color: theme(new Color(3, [])),
        fontSize: 13 + "px",
    }], ["children", singleton_1(label)]])), HtmlHelper_createElement("div", ofArray([["style", {
        fontSize: 20 + "px",
    }], ["children", singleton_1(value)]]))]]]));
}

function sensorStats(row, report) {
    return HtmlHelper_createElement("div", ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
    }], ["children", toList(delay(() => append(singleton(statTile("Status", SensorHealthModule_text(SensorRow__get_Health(row)))), delay(() => append(singleton(statTile("Availability", Format_percentOpt(Report__get_Availability(report)))), delay(() => append(singleton(statTile("Data coverage", Format_percentOpt(Report__get_DataCoverage(report)))), delay(() => append(singleton(statTile("Measurements", int32ToString(report.Points))), delay(() => append(singleton(statTile("Typical interval", Format_durationOpt(report.TypicalInterval))), delay(() => {
        const ifReported = (value_3) => {
            if (report.LastMeasurement != null) {
                return value_3;
            }
            else {
                return "-";
            }
        };
        return append(singleton(statTile("Gaps", ifReported(int32ToString(length(report.Gaps))))), delay(() => append(singleton(statTile("Missing", ifReported(Format_duration(Report__get_MissingTime(report))))), delay(() => append(singleton(statTile("Current gap", ifReported(Format_durationOpt(Report__get_CurrentGap(report))))), delay(() => append(singleton(statTile("Longest gap", ifReported(Format_durationOpt(Report__get_LongestGap(report))))), delay(() => append(singleton(statTile("Delayed measurements", int32ToString(Report__get_DelayedPoints(report)))), delay(() => append(singleton(statTile("Delayed time", Format_duration(Report__get_DelayedTime(report)))), delay(() => append(singleton(statTile("Max delay", Format_durationOpt(Report__get_MaxDelay(report)))), delay(() => append(singleton(statTile("Gap threshold", Format_duration(report.GapThreshold))), delay(() => singleton(statTile("Delay threshold", Format_duration(report.DelayThreshold)))))))))))))))))));
    }))))))))))))]]));
}

function sensorFacts(sensor) {
    const fact = (label, value) => ViewHelpers_mkRow(ofArray([TextModule_View(ofList(map((value_2) => value_2, ofArray([["size", new TextSize(0, [])], ["color", theme(new Color(3, []))], ["children", concat(label, ...": ")]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    })), value]));
    return HtmlHelper_createElement("div", singleton_1(["children", toList(delay(() => append(singleton(fact("Sensor id", SensorId__get_Value(sensor.SensorId))), delay(() => {
        let matchValue, source, matchValue_1;
        return append((matchValue = sensor.Source, (matchValue == null) ? (empty_1()) : ((source = matchValue, singleton(fact("Data source", (matchValue_1 = source.Link, (matchValue_1 == null) ? source.Name : HtmlHelper_createElement("a", ofArray([["href", matchValue_1], ["children", [source.Name]]])))))))), delay(() => {
            let arg;
            return (!sensor.Enabled ? true : !sensor.Visible) ? singleton(fact("Note", (arg = join(", ", toList(delay(() => append(!sensor.Enabled ? singleton("disabled") : empty_1(), delay(() => (!sensor.Visible ? singleton("hidden") : empty_1())))))), toText(printf("this sensor is %s in the sensor list"))(arg)))) : empty_1();
        }));
    }))))]));
}

function SensorDetailView($props) {
    const dispatch = $props.dispatch;
    const state = $props.state;
    const sensorId = $props.sensorId;
    const row = tryHead(state.Rows);
    const name = defaultArg(map_1((_arg) => _arg.Sensor.Name, row), SensorId__get_Value(sensorId));
    const loading = isLoading(state);
    const issues = IssueRow_OfSensor(name, bind(SensorRow__get_Report, row));
    return pageContainer(toList(delay(() => {
        let p_1_3, p_1_1, p_1_2;
        return append(singleton((p_1_3 = ofList(map((value_3) => value_3, singleton_1(["children", ofArray([(p_1_1 = ofList(map((value_1) => value_1, ofArray([["label", "Sensors outage report"], ["dest", "/portwind-outage-report"]])), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }), createElement(ReactRouterCrumb_View, {
            p: p_1_1,
        })), (p_1_2 = ofList(map((value_2) => value_2, singleton_1(["label", name])), {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        }), createElement(CrumbModule_View, {
            p: p_1_2,
        }))])])), {
            Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
        }), createElement(BreadCrumbsModule_View, {
            p: p_1_3,
        }))), delay(() => append(singleton(PageTitle_title(name, "Sensor outage report")), delay(() => {
            let p_1_4;
            return append(singleton(ViewHelpers_mkRow(ofArray([pageLink(new Page(5, [sensorId]), "Open the live sensor view"), (p_1_4 = ofList(map((value_4) => value_4, empty()), {
                Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
            }), createElement(SpaceModule_View, {
                p: p_1_4,
            })), pageLink(new Page(7, [sensorId, new DateTimeRange(state.RangeStart, state.RangeEnd)]), "Open the measurements of this window")]))), delay(() => append(singleton(createElement(Header, {
                state: state,
                dispatch: dispatch,
            })), delay(() => append(state.Error ? singleton(ViewHelpers_fallbackDataBanner("Could not load the sensor list.")) : (exists((_arg_2) => _arg_2.IsFallbackData, toArray(row)) ? singleton(ViewHelpers_fallbackDataBanner("PortWind database is unavailable - showing cached measurements.")) : empty_1()), delay(() => {
                let matchValue, row_1, xs_4;
                return append((matchValue = row, (matchValue != null) ? ((row_1 = matchValue, singleton((xs_4 = toList(delay(() => append(singleton(sensorFacts(row_1.Sensor)), delay(() => {
                    let xs_3;
                    const matchValue_1 = row_1.State;
                    switch (matchValue_1.tag) {
                        case 2:
                            return singleton(ViewHelpers_fallbackDataBanner("This sensor could not be queried."));
                        case 1: {
                            const report_1 = matchValue_1.fields[0];
                            return singleton((xs_3 = [section("Summary", singleton_1(sensorStats(row_1, report_1))), section("Timeline", singleton_1(createElement(TimelineBar, {
                                report: report_1,
                            })))], createElement(Fragment, defaultOf_1(), ...xs_3)));
                        }
                        default:
                            return singleton(HtmlHelper_createElement("div", singleton_1(["children", singleton_1("Reading the measurements ...")])));
                    }
                })))), createElement(Fragment, defaultOf_1(), ...xs_4))))) : (loading ? singleton(HtmlHelper_createElement("div", singleton_1(["children", singleton_1("Loading ...")]))) : singleton(HtmlHelper_createElement("div", singleton_1(["children", singleton_1(concat("No sensor named ", SensorId__get_Value(sensorId), ..."."))]))))), delay(() => singleton(section("Gaps and delays", singleton_1(issuesTable(false, issues, loading ? true : (isEmpty(issues) && isReading(state))))))));
            }))))));
        }))));
    })));
}

function AllSensorsView($props) {
    const dispatch = $props.dispatch;
    const state = $props.state;
    const loading = isLoading(state);
    const issues = useMemo(() => sortByDescending((_arg) => getTicks(_arg.Issue.From), collect_1((r) => IssueRow_OfSensor(r.Sensor.Name, SensorRow__get_Report(r)), state.Rows), {
        Compare: (x, y) => (compare_2(x, y) | 0),
    }), [state.Rows]);
    return pageContainer(toList(delay(() => append(singleton(PageTitle_title("PortWind", "Sensor outage report")), delay(() => append(singleton(createElement(Header, {
        state: state,
        dispatch: dispatch,
    })), delay(() => append(state.Error ? singleton(ViewHelpers_fallbackDataBanner("Could not load the sensor list.")) : (exists_1((_arg_1) => _arg_1.IsFallbackData, state.Rows) ? singleton(ViewHelpers_fallbackDataBanner("PortWind database is unavailable - showing cached measurements.")) : empty_1()), delay(() => append(singleton(section("Sensors", singleton_1(sensorTable(state.Rows, loading)))), delay(() => singleton(section("Gaps and delays", singleton_1(issuesTable(true, issues, loading ? true : (isEmpty(issues) && isReading(state)))))))))))))))));
}

export function PortWindOutageReportView($props) {
    const clientSessionId = $props.clientSessionId;
    const sensor = $props.sensor;
    let patternInput;
    const init_1 = init(sensor);
    patternInput = React_useElmish_Z6C327F2E(() => UseElmishHelper_programWithCustomErrorHandler(undefined, ProgramModule_mkProgram(() => init_1, (msg, state) => update(clientSessionId, msg, state), (_arg_1, _arg_1_1) => {
    })), undefined, [map_1(SensorId__get_Value, sensor)]);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const matchValue = state_1.Sensor;
    if (matchValue == null) {
        return createElement(AllSensorsView, {
            state: state_1,
            dispatch: dispatch,
        });
    }
    else {
        const sensorId = matchValue;
        return createElement(SensorDetailView, {
            sensorId: sensorId,
            state: state_1,
            dispatch: dispatch,
        });
    }
}

